import React, { useState, useEffect } from "react";
import './Curriculum.css';
import { initFacebookPixel } from '../facebookPixel';
const Curriculum = () => {
  const [level, setLevel] = useState('Intermediate');
  const [showMore, setShowMore] = useState(false);

  const handleNavClick = (level) => {
    setLevel(level);
    setShowMore(false); // Reset "Read More" when switching levels
  };

  const renderCurriculumDetails = () => {
    switch (level) {
      case 'Beginner': {
        const curriculumItems = [
          {
            title: 'Beginner Level 1',
            description: `
              1. Basics of warm-up including dynamic movements  
              2. Focus on developing agility, balance, and speed through scientific drills  
              3. Hand-eye coordination activities & Fun games  
              4. Footwork and Movement  
                - Introduction to basic footwork techniques such as the split-step, running steps, and chasse step  
              5. Basic grips (FH, BH), Under-arm forehand service practice  
                - Basic strokes: keep, lift (FH, BH), and toss  
              6. Games and Rules  
                - Introduction to basic rules of the sport  
                - Half-court games to apply learned skills in a practical, low-pressure environment  
              7. Cool-down: Dynamic and static stretching to relax muscles and prevent injury  
            `
          },
          {
            title: 'Beginner Level 2',
            description: `
              1. Specific warm-up  
              2. Basic Physical conditioning to improve speed, reflexes, stamina  
              3. Grip Techniques (FH, BH)  
              4. Shuttle control & coordination activities  
              5. Footwork & Movement - Directional splits, Running steps, Chasse steps  
              6. Strokes - Toss, Drop, Keep, Lift (FH, BH)  
              7. Inducing Game Rules  
                - Introduction to the rules of the game  
                - Full Court Game System: Understanding and practicing full-court gameplay  
              8. Dynamic & Static cool-down  
            `
          },
          {
            title: 'Beginner Level 3',
            description: `
              1. Specific warm-up  
              2. Physical Conditioning  
                - Own Body Conditioning Workouts  
                - Endurance Run  
                - Circuit Training  
                - SAQ Training  
              3. Grip Techniques  
                - FH, BH, Bevel/Corner Grip  
              4. Shuttle Control and Coordination activities  
                - Shuttle Balancing with Spins  
                - Wall Practice  
              5. Footwork and Movement  
                - Split-Step, Directional Splits, Running, Chasse, Scissor-Kick Step  
              6. Game Awareness and Rules  
                - Full Court Game Awareness  
                - Game Rules Awareness  
                - Score Counting  
              7. Service and Stroke Practice  
                - Service Drills: Practicing forehand (FH) and backhand (BH) short and long services  
                - Strokes: Expanded stroke practice including toss, drop, keep, smash, and cross keep  
                - Full Court Multi-All Types  
                - Half Court Rallies  
                - Reaction Multi-feed Drills  
              8. Fun and Competitive Drills  
                - Chinese Rally  
                - Box Game  
                - Out by Out Full Court  
              9. Cool-Down and Recovery  
                - Breathing Exercises  
                - Dynamic Stretching  
                - Static Stretching  
                - Core Workout  
            `
          }
        ];

        const displayedItems = showMore ? curriculumItems : curriculumItems.slice(0, 1);

        return (
          <div className="curriculum-content">
            <ul className="curriculum-list">
              {displayedItems.map((item) => (
                <li key={item.id} className="curriculum-item">
                  <span className="level-label">{item.id}</span>
                  <div className="curriculum-text">
                    <span className="level-title">{item.title}</span>
                    <div className="descrip">
                      {item.description.split('\n').map((line, index) => (
                        <p key={index}>{line.trim()}</p>
                      ))}
                    </div>

                  </div>
                </li>
              ))}
            </ul>
            {curriculumItems.length > 2 && (
              <div className="button-container-cirriculum">
                {!showMore && (
                  <button className="read-more-btn" onClick={() => setShowMore(true)}>
                    ▼
                  </button>
                )}
              </div>
            )}


            {/* {showMore && (
              <button className="read-less-btn" onClick={() => setShowMore(false)}>
                Show Less
              </button>
            )} */}
          </div>
        );
      }

      case 'Intermediate': {
        const curriculumItems = [
          { 
            title: 'Physical Conditioning', 
            description: 'Stamina, Endurance, Conditioning, SAQ (Speed, Agility, Quickness), Core Training.' 
          },
          { 
            title: 'Grip Techniques', 
            description: 'FH, BH, Corner/Bevel, Pan-Handle Grips.' 
          },
          { 
            title: 'Reflex and Coordination Drills', 
            description: 'Tennis Ball Reflex: Improves hand-eye coordination and reaction time. Color Indications, Racket Indications, Tag Movements: Drills to enhance visual and movement reflexes.' 
          },
          { 
            title: 'Footwork and Movement', 
            description: 'Split-Steps, Directional Splits, Running Step, Chasse Step, Scissor Kick Step, Hop & Pivot Step.' 
          },
          { 
            title: 'Gameplay Orientation and Strategy', 
            description: 'Basic Gameplay Orientation: Understanding positioning and movement during play. Strategy and Singles Tactics: Introduction to basic strategies and tactics for singles matches.' 
          },
          { 
            title: 'Service and Stroke Practice', 
            description: 'Service: Practicing forehand (FH) and backhand (BH) short, long, and flick serves. Strokes: Expanded stroke practice including toss, drop, keep, lift, tap, smash, drive, block, attack-toss, dribble, and cross-stroke variations.' 
          },
          { 
            title: 'Overall Drills', 
            description: 'All Racket Feed/Hand Feed Multi, Rally Feed Multi-Drills, 1 vs 2/3 Practice drills, Reflex Training Hand Feed, Blind-Feed Multi feed.' 
          },
          { 
            title: 'Fun and Competitive Drills', 
            description: 'Box Games, Chinese Game, Team Out by Out Games.' 
          },
          { 
            title: 'Gameplay and Tactics', 
            description: 'All Types of Rallies, Mental Toughness Basic Training.' 
          },
          { 
            title: 'Cool-Down and Recovery', 
            description: 'Breathing Workouts, Static Stretching, Dynamic Stretching, Core Workouts.' 
          }
        ];
        
        


        const displayedItems = showMore ? curriculumItems : curriculumItems.slice(0, 2);

        return (
          <div className="curriculum-content">
            <ul className="curriculum-list">
              {displayedItems.map((item) => (
                <li key={item.id} className="curriculum-item">
                  <span className="level-label">{item.id}</span>
                  <div className="curriculum-text">
                    <span className="level-title">{item.title}</span>
                    <div className="descrip">
                      {item.description.split('\n').map((line, index) => (
                        <p key={index}>{line.trim()}</p>
                      ))}
                    </div>

                  </div>
                </li>
              ))}
            </ul>
            {curriculumItems.length > 2 && (
              <div className="button-container-cirriculum">
                {!showMore && (
                  <button className="read-more-btn" onClick={() => setShowMore(true)}>
                    ▼
                  </button>
                )}
              </div>
            )}

            {/* {showMore && (
              <button className="read-more-btn" onClick={() => setShowMore(false)}>
                Show Less
              </button>
            )} */}
          </div>
        );
      }

      case 'Advanced': {
        const curriculumItems = [
          { title: 'Physical Conditioning', description: 'Gym Workouts: Resistance Training, S&C (Strength & Conditioning) Workouts, Balance and Flexibility, Endurance and SAQ (Speed, Agility, Quickness) Training' },
          { title: 'Grip Techniques', description: 'FH, BH, Corner/Bevel, Pan-Handle Grips' },
          { title: 'Reflex and Coordination Drills', description: 'Tennis Ball Reflex Training, Color Code Indications, Mirror Shadows, Man-Mark Indications' },
          { title: 'Footwork and Movement', description: 'Split-Steps, Directional Splits, Running Step, Chasse Step, Scissor Kick Step, Hop & Pivot Step' },
          { title: 'Match Preparation and Analysis', description: 'Match Analysis, Tournament Planning, Game Plan, Playing Style Training, Video Analysis, Mind Training' },
          { title: 'Service, Strokes, and Drills', description: 'Service: Practicing all types of serves (short, long, flick, etc.), Multi-Feed Drills, All Types of Rallies, Game Plan Rallies, Doubles Drills, Customized Drills, Tournament-Oriented Training, All Types of Games' },
          { title: 'Recovery and Mental Training', description: 'Mind Training, Yoga, Ice Bath, Static and Dynamic Stretching, Roller Usage, Physio' },
        ];
                

        const displayedItems = showMore ? curriculumItems : curriculumItems.slice(0, 2);

        return (
          <div className="curriculum-content">
            <ul className="curriculum-list">
              {displayedItems.map((item) => (
                <li key={item.id} className="curriculum-item">
                  <span className="level-label">{item.id}</span>
                  <div className="curriculum-text">
                    <span className="level-title">{item.title}</span>
                    <div className="descrip">
                      {item.description.split('\n').map((line, index) => (
                        <p key={index}>{line.trim()}</p>
                      ))}
                    </div>

                  </div>
                </li>
              ))}
            </ul>
            {curriculumItems.length > 2 && (
              <div className="button-container-cirriculum">
                {!showMore && (
                  <button className="read-more-btn" onClick={() => setShowMore(true)}>
                    ▼
                  </button>
                )}
              </div>
            )}

            {/* {showMore && (
              <button className="read-less-btn" onClick={() => setShowMore(false)}>
                Show Less
              </button>
            )} */}
          </div>
        );
      }

      case 'Expert': {
        const curriculumItems = [
          { title: 'Day 1 to Day 4: Foundation Building', description: 'Introduction to badminton rules, grips, and basic footwork. Simple hand-feeding drills and coordination activities. Basic agility, balance, and endurance training. Fun activities: Shuttle hunts, balloon races, and tag games.' },
          { title: 'Day 5 to Day 8: Expanding Skills', description: 'Improved footwork (scissor-kick steps), grip techniques, and coordination. Introduction to racket feeding and full-court awareness. Endurance runs, agility drills, and speed training. Fun drills like Chinese rallies and reaction-based box games.' },
          { title: 'Day 9 to Day 12: Transition to Expert Level 1', description: 'Strengthened stroke play (smash, lift, drop) with multi-shuttle drills. Faster movement with pivot and hop steps, reflex-based coordination. Strategy basics for singles and doubles play. Mental toughness and competitive match simulation.' },
          { title: 'Day 13 to Day 16: Refining Techniques', description: 'High-speed footwork patterns, reaction drills, and advanced coordination. Match planning, video analysis, and tactical game play. Strength training, flexibility, and balance exercises. Tournament-style practice games and endurance challenges.' },
          { title: 'Day 17 to Day 20: Tactical Awareness and Speed', description: 'Mastering game-based footwork and rapid decision-making. High-intensity stroke variations, pressure handling, and fast feeding. Strategy sessions on attack vs. defense play. Competitive team-based rally matches.' },
          { title: 'Day 21 to Day 24: High-Intensity Match Preparation', description: 'Game-specific fitness and power endurance workouts. Quick reflex coordination and precision movement. Advanced serving, shot placement, and deception techniques. Tournament-format practice games with performance analysis.' },
          { title: 'Day 25 to Day 28: Peak Performance Training', description: 'Strength and resistance-based agility workouts. High-speed drills focusing on execution and match readiness. Psychological training: Focus, composure, and match-day mindset. Fun team-building games to maintain motivation.' },
          { title: 'Day 29 to Day 32: Competitive Edge & Psychology', description: 'Refinement of tactical decision-making under real-game scenarios. Stress management and peak performance handling. Simulated matches with strategic feedback. Final fine-tuning of footwork, grips, and strokes.' },
          { title: 'Day 33 to Day 36: Final Tournament Simulation', description: 'Full match simulations with tournament structure and scoring. Personalized feedback, corrections, and last-minute adjustments. Mental strength training for confidence in real competitions. Closing ceremony with awards, fun activities, and recovery sessions.' },
        ];


        const displayedItems = showMore ? curriculumItems : curriculumItems.slice(0, 2);

        return (
          <div className="curriculum-content">
            <ul className="curriculum-list">
              {displayedItems.map((item) => (
                <li key={item.id} className="curriculum-item">
                  <span className="level-label">{item.id}</span>
                  <div className="curriculum-text">
                    <span className="level-title">{item.title}</span>
                    <div className="descrip">{item.description}</div>
                  </div>
                </li>
              ))}
            </ul>
            {curriculumItems.length > 2 && (
              <div className="button-container-cirriculum">
                {!showMore && (
                  <button className="read-more-btn" onClick={() => setShowMore(true)}>
                    ▼
                  </button>
                )}
              </div>
            )}

            {/* {showMore && (
              <button className="read-less-btn" onClick={() => setShowMore(false)}>
                Show Less
              </button>
            )} */}
          </div>
        );
      }

      default:
        return <div className="default-message">Select a level to see the curriculum details.</div>;
    }
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="curriculum-container">
      <h2 className="curriculum-heading">Curriculum</h2>
      <nav className="navbar">
        <button
          className={level === 'Beginner' ? 'active-nav-btn' : 'nav-btn'}
          onClick={() => handleNavClick('Beginner')}
        >
          Beginner
        </button>
        <button
          className={level === 'Intermediate' ? 'active-nav-btn' : 'nav-btn'}
          onClick={() => handleNavClick('Intermediate')}
        >
          Intermediate
        </button>
        <button
          className={level === 'Advanced' ? 'active-nav-btn' : 'nav-btn'}
          onClick={() => handleNavClick('Advanced')}
        >
          Advance
        </button>
      </nav>

      {renderCurriculumDetails()}
    </div>
  );
};

export default Curriculum;
